module.exports = __webpack_public_path__ + "img/btbu.da7d5d42.png";